import MultiTab from './MultiTab';
import './index_light.less';

export default MultiTab;
